<template>
  <!-- 配送及时率 -->
  <div class="timeliness">
    <table class="mytable">
      <thead>
        <tr>
          <th style="width:10%;">月份</th>
          <th v-for="(mon,index) in 12" :key="index">{{index+1}}月</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="background:#203bd5;text-align:center">去年配送及时率</td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100"  v-model="formData[0].oneDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[0].twoDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[0].threeDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[0].fourDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[0].fiveDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[0].sixDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[0].sevenDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[0].eightDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[0].nineDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[0].tenDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[0].elevenDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[0].twelveDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
        </tr>

        <tr>
          <td style="background:#203bd5;text-align:center">今年配送及时率</td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].oneDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].twoDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].threeDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].fourDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].fiveDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].sixDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].sevenDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].eightDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].nineDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].tenDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].elevenDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
          <td>
            <el-input type="number" oninput="if(value.length > 3) value=value.slice(0, 3);if(value> 100) value=100" v-model="formData[1].twelveDis" placeholder="请输入">
              <template slot="suffix">%</template>
            </el-input>
          </td>
        </tr>

      </tbody>
    </table>

    <div style="margin-top: 2rem;">
      <el-button @click="save" size="small" type="primary">保存设置</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/transportation/timeliness'
export default {
  components: {},
  data() {
    return {
      formData: [
        {
          // disYear: '', //配送及时率年份
          oneDis: '', //1月配送及时率
          twoDis: '', //2月配送及时率
          threeDis: '', //3月配送及时率
          fourDis: '', //4月配送及时率
          fiveDis: '', //5月配送及时率
          sixDis: '', //6月配送及时率
          sevenDis: '', //7月配送及时率
          eightDis: '', //8月配送及时率
          nineDis: '', //9月配送及时率
          tenDis: '', //10月配送及时率
          elevenDis: '', //11月配送及时率
          twelveDis: '', //12月配送及时率
        },
        {
          // disYear: '', //配送及时率年份
          oneDis: '', //1月配送及时率
          twoDis: '', //2月配送及时率
          threeDis: '', //3月配送及时率
          fourDis: '', //4月配送及时率
          fiveDis: '', //5月配送及时率
          sixDis: '', //6月配送及时率
          sevenDis: '', //7月配送及时率
          eightDis: '', //8月配送及时率
          nineDis: '', //9月配送及时率
          tenDis: '', //10月配送及时率
          elevenDis: '', //11月配送及时率
          twelveDis: '', //12月配送及时率
        },
      ],
    }
  },
  mounted() {
    api
      .list({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.formData = res.data.list
          }
        } else {
          this.$message.error(res.message)
        }
      })
  },
  methods: {
    save() {
      api.save(this.formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.timeliness { padding-top: 10px;
}
</style>